import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fill-height":""}},[_c(VLayout,{attrs:{"row":""}},[_c(VFlex,{attrs:{"xs6":"","sm5":"","md3":"","text-center":""}},[_c(VRow,[_c(VCol,{attrs:{"cols":"12"}},[_c('v-quagga',{attrs:{"onDetected":_vm.logIt,"readerTypes":_vm.renderTypes}})],1)],1),_c(VRow,[_c(VCol,{attrs:{"cols":"12"}},[_c('h1',[_vm._v(_vm._s(_vm.text))])])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }